export { default } from './ConstructorQuote';
